import { render, staticRenderFns } from "./FRM_FichasHead.vue?vue&type=template&id=ace24b88&"
import script from "./FRM_FichasHead.vue?vue&type=script&lang=js&"
export * from "./FRM_FichasHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports